import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import Breadcrumb from '@/components/breadcrumb/Breadcrumb';
import Hero from '@/components/custom/hero';
import FeatureGrid from '@/components/UspGrid/FeaturedGrid';
import ClientCustomOrder from '@/components/custom/Client-Custom-Order';
import VideoPlayer from '@/components/about/VideoPlayer';
import SectionHeading from '@/components/about/SectionHeading';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import TestimonialsSection from '@/layout/home /TestimonialSection';
import SuccessClientStories from '@/layout/home /SuccessClientStories';
import EssentiallyAllHere from '@/components/custom/Design-Kitchen';
import ConsultationModal from '@/components/consultation/consultation-modal';
import { useCustomApi } from '@/contexts/CustomApiContext';
import { useLanguage } from '@/contexts/LanguageContext';
import FeatureGrid2 from '@/components/UspGrid/FeatureGrid2';

const products= [
  {
    id: 1,
    image: "/images/custom1.webp",
    alt: "Gas cooktop"
  },
  {
    id: 2,
    image: "/images/custom2.webp",
    alt: "Stainless steel grill"
  },
  {
    id: 3,
    image: "/images/custom3.webp",
    alt: "Brick oven stove"
  },
  {
    id: 4,
    image: "/images/custom4.webp",
    alt: "Professional gas range"
  },
  {
    id: 5,
    image: "/images/custom5.webp",
    alt: "Single burner stove"
  },
  {
    id: 6,
    image: "/images/custom6.webp",
    alt: "Gas cooktop"
  },
  {
    id: 7,
    image: "/images/custom7.webp",
    alt: "Stainless steel grill"
  },
  {
    id: 8,
    image: "/images/custom8.webp",
    alt: "Brick oven stove"
  },
  {
    id: 9,
    image: "/images/custom9.webp",
    alt: "Professional gas range"
  },
  {
    id: 10,
    image: "/images/custom10.webp",
    alt: "Single burner stove"
  },
  {
    id: 11,
    image: "/images/custom11.webp",
    alt: "Gas cooktop"
  },
  {
    id: 12,
    image: "/images/custom12.webp",
    alt: "Stainless steel grill"
  },
  {
    id: 13,
    image: "/images/custom13.webp",
    alt: "Brick oven stove"
  },
  {
    id: 14,
    image: "/images/custom14.webp",
    alt: "Professional gas range"
  },
];
const DesignYourKitchen = () => {
    const videoSrc = "https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4";
    const posterImage = "/images/videoImage.png";
   const { language, toggleLanguage } = useLanguage();
               const isRTL = language === "ar";
     const [showModal, setShowModal] = useState(false);
        const [selectedForm, setSelectedForm] = useState(null);
          const{state} = useCustomApi();


          const knownFormTypes = [
            "consultation",
            "expert",
            "discount",
            "quote",
            "maintenance",
            "product_brochure",
            "contact",
          ];
      
          const consultationFields = [
            {
              name: "name",
              label: isRTL ? "الاسم" : "Name",
              placeholder: isRTL ? "أدخل اسمك هنا" : "Enter your name here",
              required: true,
            },
            {
              name: "phone",
              label: isRTL ? "رقم الجوال" : "Mobile Number",
              placeholder: isRTL ? "أدخل رقمك هنا" : "Enter your number here",
              type: "phone",
              required: true,
            },
            {
              name: "email",
              label: isRTL ? "البريد الإلكتروني" : "Email ID",
              placeholder: isRTL ? "أدخل بريدك الإلكتروني هنا" : "Enter your email ID here",
              type: "email",
              required: true,
            },
          ];
          
          
          const deriveFormTypeFromButtonText = (buttonText) => {
            const lowerText = buttonText.toLowerCase();
            return knownFormTypes.find((type) => lowerText.includes(type.replace("_", " "))) || "default";
          };
          
          const handleOpenByButtonText =  (buttonText) => {
            console.log(buttonText,"buttontext");
            const derivedType = deriveFormTypeFromButtonText(buttonText);
           
            
            const form =
              state?.forms?.length > 0 &&
              state.forms.find(
                (f) => f.form_type?.toLowerCase() === derivedType
              );
          
            console.log(form, "matched form");
            setSelectedForm(form);
          };
  return (
    <>
      <Breadcrumb />
      <Hero 
       showModal={showModal} setShowModal={setShowModal} isRTL={isRTL} selectedForm={selectedForm} consultationFields={consultationFields} form_type={"consultation"}  handleOpenByButtonText={handleOpenByButtonText}
      title={isRTL ? "صمِّم مطبخك باحترافية" : "Arm Your Kitchen with"}
      subtitle={isRTL ? "وميِّزه بالكفاءة والإنتاجية" : "Efficiency & Productivity!"}
      description={isRTL ? <> قم ببناء مطبخ مصمَّم بدقة مدروسة، من الصفر،
باستخدام حلول التصميم الذكي والتنفيذ الاحترافي.</> :<> Build a meticulously-engineered kitchen from scratch, using smart<br/>
design solutions and professional executions.</>}
                button_text={isRTL ? "اطلب استشارة مجانية" : "Ask for a free consultation"}
      />
      <section className="container mt-5 md:mt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-12 lg:gap-[80px]">
          <div className=''>
            <h2 className="text-2xl md:text-3xl lg:text-[36px] font-semibold font-primary tracking-wide mb-5 md:mb-12">
          {isRTL ? "بناء مطبخ عالي الأداء بتصاميم ذكية وهندسة متخصصة" : "Build a High-Performance Kitchen with Smart Designs and Expert Engineering"}
            </h2>

            <div className="">
              {/* Text Content */}
              <div className=" animate-fade-in">
              <p className="font-primary font-semibold text-sm 3xl:text-base text-[#737373] text-justify tracking-wide">
   {isRTL ? "في ستيل كيتشن، نحن نساعدك في الحصول على المطبخ المثالي الذي يتناسب مع احتياجاتك ومع المساحة المتاحة لديك. سواء كنت ترغب في تجديد مطبخك أو بنائه من الصفر، وبغض النظر عن مساحته، سنمكِّنك من الحصول على أذكى الحلول والتصاميم، وسنوفِّر لك إمكانية العمل في:" : "At Steel Kitchen, we help you to get the perfect kitchen that is convenient and compatible with your needs, and your space capabilities. Whether you need to renew your kitchen, or to build it from scratch, and regardless of its space, be sure you will get the smartest solution and design, and you will work in:"}   </p>

  <ul className="list-disc pl-5 mt-4 text-[#737373] text-sm 3xl:text-base font-primary font-semibold tracking-wide space-y-2">
    <li>
    {isRTL ? "مطبخ ذي كفاءة عالية، مصمَّم بتخطيط منطقي لزيادة الإنتاجية إلى أقصى حد." : "Efficient kitchen that is designed with a logical workflow and layout to maximize productivity."}  
    </li>
    <li>
     {isRTL ? "مطبخ مطابق لجميع لوائح وتعليمات الصحة والأمان وملتزم بقواعد البناء." : "Compliant kitchen that meets all relevant health, safety, and building code regulations."} 
    </li>
    <li>
    {isRTL ? "مطبخ احترافي مجهَّز بمعدات تجارية عالية الجودة ومصمَّمة لتتحمل الاستخدام الكثيف والمتواصل." : "Professional-grade kitchen with heavy-duty, commercial-quality equipment built to withstand constant, intensive use."}
    </li>
    <li>
     {isRTL ? "مطبخ منظَّم يحتوي على مساحات خاصة بالتحضير، والتخزين، والتنظيف." : "Organized kitchen with clearly designated prep areas, storage, and cleaning stations."}
    </li>
    <li>
     {isRTL ? "مطبخ متعدد الاستخدامات مصمَّم ليستوعب عدة طرق من الطهي لتنفيذ قائمة الطعام المتنوعة لديك." : "Versatile kitchen that is designed to accommodate a diverse menu and variety of cooking methods."}
    </li>
  </ul>

  <p className="font-primary font-semibold text-sm 3xl:text-base text-[#737373] text-justify tracking-wide mt-6">
  {isRTL ? "إذا كان لديك (مقهى، مطعم، مخبز أو فرن، فندق، مستشفى، سوبرماركت، فيلا أو قصر، وغيرها)، فإن ستيل كيتشن، كواحدة من أفضل وأمهر شركات تصميم وبناء المطابخ في (الإمارات العربية المتحدة، دول مجلس التعاون الخليجي، وكافة دول العالم) منذ عام 2000، ستساعدك في بناء مطبخ يدعم عملك ويرفع خدماتك وأطباقك إلى مستوى عالٍ من الاحتراف." : "If you have a (coffee shop, restaurant, bakery & pizzeria, hotel, hospital, supermarket, villa or palace, etc.), Steel Kitchen, as one of the best and reliable kitchen designers and builders in (UAE, GCC, and worldwide) since 2000, can assist you to build the culinary arsenal that supports your work and makes your outputs on a high level of professionalism."}  
  </p>
                <div className="pt-4 pb-4 sm:pb-0">
                <ConsultationModal
        open={showModal}
        setOpen={setShowModal}
        backgroundImage={"/images/ask-consultation.jpeg"}
        title={isRTL ? selectedForm?.title_ar : selectedForm?.title_en}
        subtitle={isRTL ? selectedForm?.description_ar : selectedForm?.description_en}
        fields={consultationFields}
        form_type= {selectedForm?.id}
        isRTL={isRTL}
        buttonText= {isRTL ? "اطلب استشارة مجانية" :  "Ask for a free consultation"}
        trigger={ 
        <Button onClick={() => handleOpenByButtonText("Ask for a free consultation")}  className="group bg-[#262626] hover:text-white text-white px-4 sm:px-4 py-4 sm:py-3 rounded-[8px] text-sm sm:text-base font-primary font-semibold relative overflow-hidden flex items-center">
        <span className="absolute top-0 left-[-100%] w-full h-full bg-[#D02C2A] transition-all duration-300 ease-out group-hover:left-0"></span>
        <span className="relative z-20 flex items-center">
        {isRTL ? "اطلب استشارة مجانية" :  "Ask for a free consultation"}
       {isRTL ?    <FaChevronLeft className="w-3 h-3 ml-3" /> :   <FaChevronRight className="w-3 h-3 ml-3" />}  
        </span>
      </Button>}
      />  
                  
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="animate-scale-in">
            <img 
              src="/images/design-kitchen.png" 
              alt="Kitchen equipment illustration" 
              className="w-full 3xl:w-full h-full rounded-md shadow-sm"
            />
          </div>
        </div>
      </section>
      
      <div className='mt-5 md:mt-20'>
      <FeatureGrid2 isRTL={isRTL}/>
      </div>

<EssentiallyAllHere isRTL={isRTL}/> 

      <ClientCustomOrder title={isRTL ? "بعضاً من مشاريعنا السابقة" : "Some of Our Executed Projects"} description={isRTL ? "طلباتنا المُخصَّصة مُصمَّمة لتلبية احتياجاتكم ومتطلباتكم الخاصة. نُقدم حلولاً عالية الجودة ومتينة بكل دقة واحترافية." : <>See our successfully executed projects, designed to meet unique client <br/> needs with excellence </>} products={products} size={3} />
      <div className="px-4 sm:px-6 md:px-8 lg:px-10">
      <section className=" py-10 md:py-20 bg-kitchen-gray rounded-[40px] mt-10 md:mt-20 bg-[#F8F8F8]">
        <div className="grid grid-cols-1 lg:grid-cols-[58%_32%] gap-10 md:gap-20">
  <div className="px-4 sm:px-6 md:px-8 lg:px-10">
  <VideoPlayer
  videoSrc="https://www.youtube.com/watch?v=IF2_ghCXDp8"
  posterImage={posterImage}
/>
  </div>
  
  <div className="lg:max-w-2xl px-4 lg:px-0 flex flex-col justify-between ">
    <SectionHeading 
    isRTL={isRTL}
      subtitle={isRTL ? "داخل مصنعنا:" : "Inside Our Factory:"} 
      title={isRTL ? "حيث تلتقي الخبرة مع التميُّز في التصنيع": "Where Expertise Meets Manufacturing Excellence" }
    />
    <div>
    <p className="font-primary font-semibold text-sm 3xl:text-base text-justify text-[#262626] mb-4">
   {isRTL ? "باستخدام خامات ومواد عالية الجودة ومتينة، وعبر التنفيذ الاحترافي، نضمن التميُّز في كل منتج." : "Using high-quality and durable materials, and with professional execution,  we ensure excellence in every product."}
    </p>
    
    <ConsultationModal
        open={showModal}
        setOpen={setShowModal}
        backgroundImage={"/images/ask-consultation.jpeg"}
        title={isRTL ? selectedForm?.title_ar : selectedForm?.title_en}
        subtitle={isRTL ? selectedForm?.description_ar : selectedForm?.description_en}
        fields={consultationFields}
        form_type= {selectedForm?.id}
        isRTL={isRTL}
        buttonText= {isRTL ? "اطلب استشارة مجانية" :  "Ask for a free consultation"}
        trigger={ 
          <Button  onClick={() => handleOpenByButtonText("Ask for a free consultation")} className="group bg-[#262626] hover:text-white text-white px-4 sm:px-4 py-4 sm:py-3 rounded-lg text-sm sm:text-base  font-primary font-semibold relative overflow-hidden flex items-center">
                         <span className="absolute top-0 left-[-100%] w-full h-full bg-[#D02C2A] transition-all duration-300 ease-out group-hover:left-0"></span>
                         <span className="relative z-20 flex items-center"> 
                        {isRTL ? "اطلب استشارة مجانية" :  "Ask for a free consultation"}
                        {isRTL ?    <FaChevronLeft className="w-3 h-3 ml-3" /> :   <FaChevronRight className="w-3 h-3 ml-3" />}  
                         </span>
                       </Button>
       }
      />  
   {/* <Button className="group bg-[#262626] hover:text-white text-white px-4 sm:px-4 py-4 sm:py-3 rounded-lg text-sm sm:text-base  font-primary font-semibold relative overflow-hidden flex items-center">
                         <span className="absolute top-0 left-[-100%] w-full h-full bg-[#D02C2A] transition-all duration-300 ease-out group-hover:left-0"></span>
                         <span className="relative z-20 flex items-center"> 
                         Ask for a free consultation
                           <FaChevronRight className="w-3 h-3 ml-3" />
                         </span>
                       </Button> */}
    </div>
  </div>
</div>

        </section>
  </div>

  <TestimonialsSection/>
  <SuccessClientStories/>
    </>
  );
};

export default DesignYourKitchen;
